/**
 * Formata data/hora para o botao do seletor (pt-BR).
 */
export function formatarDataHoraPtBr(data: Date): string {
  return new Intl.DateTimeFormat("pt-BR", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  }).format(data);
}

/**
 * Extrai `HH:mm` de um Date no fuso local.
 */
export function horaLocalDe(data: Date): string {
  const h = String(data.getHours()).padStart(2, "0");
  const m = String(data.getMinutes()).padStart(2, "0");
  return `${h}:${m}`;
}

/**
 * Combina um dia (calendario) com hora `HH:mm`, preservando segundos zerados.
 */
export function combinarDiaEHora(dia: Date, hora: string): Date {
  const partes = hora.split(":");
  const horas = Number(partes[0] ?? "0");
  const minutos = Number(partes[1] ?? "0");
  const proxima = new Date(dia);
  proxima.setHours(
    Number.isFinite(horas) ? horas : 0,
    Number.isFinite(minutos) ? minutos : 0,
    0,
    0,
  );
  return proxima;
}

/**
 * Inicio do dia local (para desabilitar datas passadas no calendario).
 */
export function inicioDoDiaLocal(referencia: Date = new Date()): Date {
  const d = new Date(referencia);
  d.setHours(0, 0, 0, 0);
  return d;
}
